import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import {
  ICPLAuthCompanyBrandingClient,
  CompanyBrandingModel,
  LoginScreenNarrativeModel,
} from "./api/cplauthapi/CPLAuthAPI";
import { UpdateCompanyBrandingModel } from "./classes/UpdateCompanyBrandingModel";
import { NewCompanyBrandingModel } from "./classes/NewCompanyBrandingModel";

export interface ICompanyBrandingService {
  createNewCompanyBranding(companyBrandingModel: NewCompanyBrandingModel): Promise<void>;
  getCompanyBranding(): Promise<CompanyBrandingModel>;
  updateCompanyBranding(companyBrandingModel: UpdateCompanyBrandingModel): Promise<void>;
  getCompanyLoginScreenNarrative(): Promise<LoginScreenNarrativeModel>;
  createNewCompanyLoginScreenNarrative(loginScreenNarrative: string): Promise<void>;
  updateCompanyLoginScreenNarrative(loginScreenNarrative: LoginScreenNarrativeModel): Promise<void>;
}

@injectable()
export class CompanyBrandingService implements ICompanyBrandingService {
  @inject(SERVICE_TYPES.CPLAuthCompanyBrandingClient) cplAuthCompanyBrandingClient!: ICPLAuthCompanyBrandingClient;

  async createNewCompanyBranding(companyBrandingModel: NewCompanyBrandingModel): Promise<void> {
    return this.cplAuthCompanyBrandingClient.createNewCompanyBranding(companyBrandingModel);
  }

  async getCompanyBranding(): Promise<CompanyBrandingModel> {
    return this.cplAuthCompanyBrandingClient.getCompanyBranding();
  }

  async updateCompanyBranding(companyBrandingModel: UpdateCompanyBrandingModel): Promise<void> {
    return this.cplAuthCompanyBrandingClient.updateCompanyBranding(companyBrandingModel);
  }

  async getCompanyLoginScreenNarrative(): Promise<LoginScreenNarrativeModel> {
    return this.cplAuthCompanyBrandingClient.getCompanyLoginScreenNarrative();
  }

  async createNewCompanyLoginScreenNarrative(loginScreenNarrative: string): Promise<void> {
    return this.cplAuthCompanyBrandingClient.createNewCompanyLoginScreenNarrative(loginScreenNarrative);
  }

  async updateCompanyLoginScreenNarrative(loginScreenNarrative: LoginScreenNarrativeModel): Promise<void> {
    return this.cplAuthCompanyBrandingClient.updateCompanyLoginScreenNarrative(loginScreenNarrative);
  }
}
